import { render } from "./commResItem.vue?vue&type=template&id=da21101a&scoped=true"
import script from "./commResItem.vue?vue&type=script&lang=js"
export * from "./commResItem.vue?vue&type=script&lang=js"

import "./commResItem.vue?vue&type=style&index=0&id=da21101a&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da21101a"]])

export default __exports__